import React from 'react';
import ReactDOM from 'react-dom/client';
import './tokens.css';
import './index.css';
import App from './App';
import { initAnalytics } from './utils/analytics';

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
